import { useContext } from 'react';
import UserContext from '~/context/common/UserContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';
import { FavoriteVehicle } from '~/contracts/common';
import { RecommendedVehicle } from '~/contracts/vdp';
import { SuggestedVehicle } from '~/services/home/contracts/SuggestedVehiclesData';

export enum VDPLinkTitles {
  Favorite = 'Favorite vehicles',
  Recent = 'Recently viewed',
  Suggested = 'Suggested vehicles',
  None = ''
}

type HookReturnType = {
  header: VDPLinkTitles;
  vehicles: FavoriteVehicle[] | RecommendedVehicle[] | SuggestedVehicle[];
  showLoading: boolean;
  showLink?: boolean;
};

export default function useGetVDPLinksToShow(): HookReturnType {
  const {
    favorites: { data: favoriteVehicles, isLoaded: isFavoritesLoaded }
  } = useContext(UserContext);
  const {
    recentVehiclesFromSearch: { data: recentVehicles, isLoaded: isRecentLoaded }
  } = useContext(RecentVehiclesContext);
  const {
    suggestedVehicles: { data: suggestedVehicles, isLoaded: isSuggestedLoaded }
  } = useContext(SuggestedForYouContext);

  const hasFavorites = favoriteVehicles.length > 0;
  const hasRecentVehicles = recentVehicles.length > 0;
  const hasSuggestedVehicles = suggestedVehicles.length > 0;

  const allLoaded = isFavoritesLoaded && isRecentLoaded && isSuggestedLoaded;

  if (!allLoaded) {
    return { header: VDPLinkTitles.None, vehicles: [], showLoading: true };
  }

  if (hasFavorites) {
    return {
      header: VDPLinkTitles.Favorite,
      vehicles: favoriteVehicles.slice(0, 3),
      showLoading: false,
      showLink: favoriteVehicles.length > 3
    };
  }

  if (!hasFavorites && hasRecentVehicles) {
    return {
      header: VDPLinkTitles.Recent,
      vehicles: recentVehicles.slice(0, 3),
      showLoading: false
    };
  }

  if (!hasFavorites && !hasRecentVehicles && hasSuggestedVehicles) {
    return {
      header: VDPLinkTitles.Suggested,
      vehicles: suggestedVehicles.slice(0, 3),
      showLoading: false
    };
  }

  return { header: VDPLinkTitles.None, vehicles: [], showLoading: true };
}
